<template>

  <div
    class="feed-content"
    :class="{'box-loading': loading}">
    
    <div
      class="photo"
      v-if="!edit && activity.author_user">
      <Avatar
        :src="imgSrc"
        :name="activity.author_user.name"
        size="40px"
        radius="20px"
        resize="100x100x1" />
    </div>

    <div
      class="content"
      v-if="!edit">
      
      <div
        v-if="permissions.includes('manage_candidates')"
        class="feed-actions dropdown">
        <button
          class="btn btn-sm btn-light"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-chevron-down" />
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            @click="editTask(activity.task)">
              <i class="fas fa-pencil-alt" /> {{ $t('Edit') }}
            </button>
          <button
            class="dropdown-item"
            @click="deleteTask(activity.task._id)">
              <i class="fas fa-times" /> {{ $t('Remove') }}
            </button>
        </div>
      </div>

      <div>
        <strong>Lembrar</strong>
        <span v-if="activity.task.assigned_user_id">{{ activity.task.assigned_user_id.name }}</span> em 
        <strong>{{ $d(new Date(activity.task.date), 'long') }}</strong>
      </div>

      <div class="d-flex mt-2">
        <div
          class="check-task mr-2"
          :class="{'completed': activity.task.completed}"
          @click="checkCompleted(!activity.task.completed)">
          <i class="far fa-check-circle" v-if="!activity.task.completed" />
          <i class="fas fa-check-circle" v-if="activity.task.completed" />
        </div>
        <div class="w-100 align-self-center">
          <div style="white-space: pre-wrap;">{{ activity.task.comment }}</div>
        </div>
      </div>
      
      <div class="mt-2">
        <small>
          <span
            v-tooltip="$d(new Date(activity.created_at), 'long')">
            {{ $d(new Date(activity.created_at), 'short') }}
            </span>
          <span>
            por {{ activity.author_user.name }} - 
            </span>
          <router-link
            class="link-discreet"
            :to="{path: '/job/' + activity.job._id }">
            {{ activity.job.title }}
            </router-link>
        </small>
      </div>
    </div>

    <div class="content" v-if="edit">
      <candidate-task-form
        :initValue="edit"
        @updated="updatedTask"
        @cancel="editCancel">
        </candidate-task-form> 
    </div>
    
  </div>

</template>

<script>
import config from '@/config'
import CandidateTaskForm from '../Task/CandidateTaskForm'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'CandidateFeedTaskItem',
  components: {
    CandidateTaskForm,
    Avatar
  },
  props: [
    'activity'
  ],
  data () {
    return {
      loading: false,
      edit: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.author_user.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    editTask (data) {
      this.edit = data
    },
    editCancel () {
      this.edit = false
    },
    updatedTask () {
      this.$store.dispatch('getActivities', {
        _id: this.activity._id
      })
      .then(() => {
        this.edit = false
      })
    },
    deleteTask (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteTask', id)
        .then((result) => {
          return this.$store.dispatch('deleteActivity', this.activity._id)
        })
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    checkCompleted (completed) {
      this.loading = true

      this.$store
      .dispatch('updateTask', {
        _id: this.activity.task._id,
        completed: completed
      })
      .then((result) => {
        return this.$store.dispatch('getActivities', {
          _id: this.activity._id
        })
      })
      .then((result) => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.check{
  font-size: 1.7em;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedTaskItem.vue